import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainerWithStep,
} from "../Part3/rendez-vous-part-3.module.scss"
import {
  rendezVousPart4Container,
  rendezVousPart4FormContainer,
  rendezVousPart4CaseCochable,
} from "./rendez-vous-part-4.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousPart4Input,
  RendezVousPart4TextArea,
  RendezVousInputType,
} from "../rendez-vous-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"

export const RendezVousPart4 = ({
  contactInfo,
  setContactInfo,
  casesCochables,
  step,
}) => {
  const handleChange = (event) => {
    setContactInfo({ ...contactInfo, [event.target.name]: event.target.value })
  }

  const handleCheckbox = (event) => {
    const index = event.target.getAttribute("data-index")
    const cases = contactInfo.cases
    cases[index] = event.target.checked
    setContactInfo({ ...contactInfo, cases: cases })
  }

  return (
    <RendezVousSubContainer className={rendezVousSubContainerWithStep}>
      <StepIndicator step={step} />
      <RendezVousTitle className={rendezVousTitle}>
        Informations de contact
      </RendezVousTitle>
      <div className={rendezVousPart4Container}>
        Pour la gestion de votre rendez-vous, nous avons besoin de vos
        informations de contact. Veuillez bien remplir les champs ci-dessous
        (tous les champs marqués d&apos;une * sont obligatoires).
        <div className={rendezVousPart4FormContainer}>
          <form>
            <label htmlFor="prenom">
              Prénom*
              <RendezVousPart4Input
                type="text"
                id="prenom"
                name="prenom"
                onChange={handleChange}
                value={contactInfo.prenom}
                required
              />
            </label>
            <label htmlFor="nom">
              Nom*
              <RendezVousPart4Input
                type="text"
                id="nom"
                name="nom"
                onChange={handleChange}
                value={contactInfo.nom}
                required
              />
            </label>
            <label htmlFor="phone">
              Téléphone*
              <RendezVousPart4Input
                type="tel"
                id="phone"
                name="phone"
                onChange={handleChange}
                value={contactInfo.phone}
                required
              />
            </label>
            <label htmlFor="mail">
              E-mail
              <RendezVousPart4Input
                type="email"
                id="mail"
                name="mail"
                value={contactInfo.mail}
                onChange={handleChange}
              />
            </label>
            <label htmlFor="comm">
              Commentaire
              <RendezVousPart4TextArea
                type="text"
                rows={10}
                id="comm"
                name="comm"
                value={contactInfo.comm}
                onChange={handleChange}
              />
            </label>
            {casesCochables &&
              casesCochables.map((caseCochable, index) => (
                <label
                  className={rendezVousPart4CaseCochable}
                  htmlFor={"case" + index}
                  key={index}
                >
                  <RendezVousInputType
                    type="checkbox"
                    name={"case" + index}
                    id={"case" + index}
                    checked={contactInfo.cases[index]}
                    onChange={handleCheckbox}
                    data-index={index}
                  />{" "}
                  <span>{caseCochable.value}</span>
                </label>
              ))}
          </form>
        </div>
      </div>
    </RendezVousSubContainer>
  )
}

RendezVousPart4.propTypes = {
  contactInfo: PropTypes.object,
  setContactInfo: PropTypes.func,
  casesCochables: PropTypes.array,
  step: PropTypes.number,
}
